<template>
  <v-app id="inspire">
    <v-navigation-drawer
            v-model="drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
    >
      <v-list dense>
          <v-list-item-group v-model="selectedRocnik" color="brown">
            <v-list-item link v-for="item in rocniky" v-bind:key="item" @click="selectRocnik(item)">
              <v-list-item-action>
                <v-icon>mdi-book-open-variant</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
            app
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="brown"
            dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title
              style="width: 300px"
              class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Archiv CB6</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <audio controls="controls" ref="player" style="margin-top: 5px" @ended="playNext($event)">
          <source v-bind:src="currentPlayerItem" type="audio/mpeg">
        </audio>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <v-container
              fluid
      >
        <v-data-table
                :headers="headers"
                :items="kazani"
                :items-per-page="20"
                class="elevation-1"
                :sort-by="sort_by"
                :sort-desc="sort_desc"
        >

            <template v-slot:item.date="{ item }">
                {{ $date(item.date).format('DD.MM.YYYY') }}
            </template>

            <template v-slot:item.length="{ item }">
                {{ item.length }} min
            </template>

            <template v-slot:item.kazatel_icon="{ item }">
                <v-avatar size="36">
                    <img
                            :src="'/' + item.kazatel_icon"
                            v-if="item.kazatel_icon"
                    >

                </v-avatar>
          </template>

          <template v-slot:item.filename="{ item }">
              <a :href="'/' + item.filename" style="text-decoration: none;"><v-icon>mdi-download</v-icon></a>
              <a href="#" @click="play(item, kazani)" style="text-decoration: none;"><v-icon>mdi-headphones</v-icon></a>
          </template>
        </v-data-table>
      </v-container>
    </v-content>
    <v-footer
            color="brown"
            app
    >
      <span class="white--text">&copy; 2019</span>
    </v-footer>
  </v-app>
</template>

<script>
  import 'dayjs'

  export default {
    props: {
      source: String,
    },
      mounted: function () {
          this.$watch('currentPlayerItem', function() {
              this.$refs.player.load()
              this.$refs.player.play()
          });
      },
      created: function() {
          fetch('/api/config')
              .then((response) => {
                  return response.json()
              })
              .then((jsonBody) => {
                  this.years = jsonBody;
                  this.selectRocnik(2020);
              })
      },
    methods: {
        selectRocnik: function(rocnik) {
            this.kazani = this.years[rocnik];
            this.selectedRocnik = ''+rocnik;
        },
        play: function(item, kazani) {
            this.currentPlayerItem = '/' + item.filename;

            if (kazani) {
                const orderedKazani = kazani.sort((kazaniItem1, kazaniItem2) => kazaniItem1.date.localeCompare(kazaniItem2.date)).reverse();
                const currentItemIndex = orderedKazani.indexOf(item);
                console.log(currentItemIndex)
                if (currentItemIndex >= 0) {
                    this.currentPlaylist = orderedKazani.slice(currentItemIndex + 1)
                    console.log(this.currentPlaylist)
                } else {
                    this.currentPlaylist = []
                    console.log(this.currentPlaylist)
                }
            }

        },
        playNext: function() {
            if (this.currentPlaylist && this.currentPlaylist.length > 0) {
                this.play(this.currentPlaylist[0], this.currentPlaylist)
            }
        }
    },
    data: () => ({
      drawer: null,
      currentPlayerItem: null,
      currentPlaylist: [],
      years: {},
      selectedRocnik: null,
      sort_by: 'date',
      sort_desc: true,
      headers: [
        { text: 'Datum', value: 'date' },
          { text: '', value: 'kazatel_icon', sortable: false },
        { text: 'Kazatel', value: 'kazatel' },
        { text: 'Název', value: 'title' },
        { text: 'Serie', value: 'serie' },
        { text: 'Text', value: 'text', sortable: false },
        { text: 'Délka', value: 'length' },
        { text: '', value: 'filename', sortable: false },
      ],
      kazani: []
    }),
    computed: {
        rocniky: function() {
            return Object.keys(this.years).sort().reverse();
        }
    }
  }
</script>
